import { useEffect, useState } from "react";
import api from "../services/api";
import { useNavigate } from "react-router-dom";
import { formatDate } from "./TableAddPayments";

function ProductsList() {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setIsLoading(true);
        const response = await api.get("/products");
        setProducts(response.data);
      } catch (error) {
        console.error("Erro ao obter produtos: ", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchProducts();
  }, []);

  if (isLoading) return <h1>Carregando....</h1>;

  return (
    <div className="w-full flex justify-center mt-20 relative">
      <button
        className="absolute right-4 -top-16 bg-orange-500 px-4 py-2 text-white font-semibold rounded-md"
        onClick={() => navigate("/produtos/criar")}
      >
        CRIAR PRODUTO
      </button>
      {products.length === 0 ? (
        <p className="text-2xl font-semibold text-center mt-12">
          Não há produtos cadastrados!
        </p>
      ) : (
        <table className="w-[80%] rounded-lg border-separate border-spacing-y-4">
          <thead>
            <tr>
              <th></th>
              <th>Quantidade Comprada (Não recebida)</th>
              <th>Último preço</th>
              <th>Próxima carga</th>
            </tr>
          </thead>
          <tbody>
            {products.map((product) => {
              return (
                <tr
                  key={product.id}
                  className="bg-gray-200 rounded-lg h-12 hover:cursor-pointer"
                  onClick={() => navigate(`/produtos/detalhes/${product.id}`)}
                >
                  <td className="capitalize font-bold pl-4">{product.name}</td>
                  <td className="text-center">{product.quantityPurchased}</td>
                  <td className="text-center">
                    {product.target_value &&
                      `$${parseFloat(product.target_value).toFixed(2)}`}

                    {product.unit_value &&
                      ` ($${parseFloat(product.unit_value).toFixed(2)})`}
                  </td>
                  <td className="text-center">
                    {product.nextOrderLoadDate
                      ? formatDate(product.nextOrderLoadDate)
                      : ""}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}
export default ProductsList;
